"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFunction = void 0;
exports.isFunction = function (fn) { return typeof fn === 'function'; };
